import { IDestroyOptions, Text } from "pixi.js";
import { MyWalletDataTextStyle, MyWalletDataView } from "./MyWalletDataView";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { Event } from "event-system";
import { MyWalletSwitchNetworkTooltip } from "./MyWalletSwitchNetworkTooltip";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";

export class MyWalletNetworkDataView extends MyWalletDataView {
    public readonly onSwitchNetwork: Event<void>;

    private static readonly DESCRIPTION_TEXT = 'NETWORK\nTYPE';

    private readonly networkTypeText: Text;
    private readonly switchNetworkButton?: ButtonWithScaleAnimation;
    private readonly switchNetworkTooltip?: MyWalletSwitchNetworkTooltip;

    private selectedSupportedNetwork: boolean;

    public set networkType(walletNetworkType: string) {
        this.networkTypeText.text = walletNetworkType.toUpperCase();
        this.adjustText();
    }

    public set supportedNetwork(value: boolean) {
        if (value === this.selectedSupportedNetwork) {
            return;
        }
        this.selectedSupportedNetwork = value;

        this.descriptionText.style.fill = value ? 'BCD8F2' : 'DF0462';
        this.networkTypeText.style.fill = value ? 'BCD8F2' : 'DF0462';
        this.networkTypeText.eventMode = value ? 'none' : 'static';
        this.switchNetworkButton.visible = !value;
        this.adjustText();
    }

    public constructor(
        myWalletResources: MyWalletResourcePackage,
        commonResources: CommonResourcesPackage,
        networkType: string,
        supportedNetwork: boolean
    ) {
        super(myWalletResources, MyWalletNetworkDataView.DESCRIPTION_TEXT);
        this.selectedSupportedNetwork = supportedNetwork;
        this.networkTypeText = new Text(networkType.toUpperCase(), new MyWalletDataTextStyle());
        this.addChild(this.networkTypeText);

        this.switchNetworkButton = new ButtonWithScaleAnimation(myWalletResources.assets_views_my_wallet_ui_other_network_icon_png);
        this.switchNetworkButton.position.set(this.width - this.switchNetworkButton.width - 20, this.textFieldPlaceholder.height * 0.5 - this.switchNetworkButton.height * 0.5);
        this.switchNetworkButton.visible = false;
        this.addChild(this.switchNetworkButton);

        this.switchNetworkTooltip = new MyWalletSwitchNetworkTooltip(myWalletResources, commonResources);
        this.switchNetworkTooltip.position.set(120, -34);
        this.switchNetworkTooltip.visible = false;
        this.addChild(this.switchNetworkTooltip);

        this.onSwitchNetwork = new Event<void>();
        this.switchNetworkTooltip.onCloseButtonClick.add(this.onTooltipCloseButtonClickHandle, this);
        this.switchNetworkTooltip.onTextClick.add(this.onSwitchNetworkClickHandle, this);
        this.switchNetworkButton.onUp.add(this.onSwitchNetworkClickHandle, this);
        this.networkTypeText.on('pointerup', this.onNetworkNameClickHandle, this);

        if (!this.selectedSupportedNetwork) {
            this.descriptionText.style.fill = 'DF0462';
            this.networkTypeText.style.fill = 'DF0462';
            this.networkTypeText.eventMode = 'static';
            this.switchNetworkButton.visible = true;
        }
        this.adjustText();
    }

    private onSwitchNetworkClickHandle(): void {
        this.switchNetworkTooltip.visible = false;
        if (this.supportedNetwork) {
            return;
        }
        this.onSwitchNetwork.emit();
    }

    private onNetworkNameClickHandle(): void {
        if (this.supportedNetwork) {
            return;
        }
        this.switchNetworkTooltip.visible = true;
    }

    private onTooltipCloseButtonClickHandle(): void {
        this.switchNetworkTooltip.visible = false;
    }

    private adjustText(): void {
        this.networkTypeText.scale.set(1);
        const fieldSize = this.selectedSupportedNetwork ? this.textFieldPlaceholder.width : this.textFieldPlaceholder.width - (this.switchNetworkButton.width + 30) * 2;
        if (this.networkTypeText.width > fieldSize) {
            this.networkTypeText.scale.set(fieldSize / this.networkTypeText.width);
        }
        this.networkTypeText.position.set(this.textFieldPlaceholder.position.x + (this.textFieldPlaceholder.width - this.networkTypeText.width) * 0.5, (this.textFieldPlaceholder.height - this.networkTypeText.height) * 0.5);
        if (this.networkTypeText.width > fieldSize) {
            this.networkTypeText.position.x -= 10;
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.switchNetworkTooltip?.onCloseButtonClick.remove(this.onTooltipCloseButtonClickHandle, this);
        this.switchNetworkTooltip?.onTextClick.remove(this.onSwitchNetworkClickHandle, this);
        this.switchNetworkButton?.onUp.remove(this.onSwitchNetworkClickHandle, this);
        this.networkTypeText?.off('pointerup', this.onNetworkNameClickHandle, this);
        super.destroy(options);
    }
}